__turbopack_context__.v({
  "className": "ibm_plex_sans_db56629-module__CJvePa__className",
  "variable": "ibm_plex_sans_db56629-module__CJvePa__variable",
});
